/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Filmstrip_Frame_CountInputs */

const en_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Film Strip Frames`)
};

const fr_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cadres de pellicule`)
};

const de_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filmstreifenbilder`)
};

const it_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotogrammi della striscia di pellicola`)
};

const ru_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Кадры кинопленки`)
};

const es_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotogramas de tira de película`)
};

const zh_cn2_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`胶片帧`)
};

const ja_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フィルムストリップのフレーム`)
};

const hi_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फिल्म स्ट्रिप फ्रेम`)
};

const pt_pt2_options_editor_filmstrip_frame_count = /** @type {(inputs: Options_Editor_Filmstrip_Frame_CountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fotogramas de tira de filme`)
};

/**
* | output |
* | --- |
* | "Film Strip Frames" |
*
* @param {Options_Editor_Filmstrip_Frame_CountInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_filmstrip_frame_count = /** @type {((inputs?: Options_Editor_Filmstrip_Frame_CountInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Filmstrip_Frame_CountInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_filmstrip_frame_count(inputs)
	if (locale === "de") return de_options_editor_filmstrip_frame_count(inputs)
	if (locale === "it") return it_options_editor_filmstrip_frame_count(inputs)
	if (locale === "ru") return ru_options_editor_filmstrip_frame_count(inputs)
	if (locale === "es") return es_options_editor_filmstrip_frame_count(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_filmstrip_frame_count(inputs)
	if (locale === "ja") return ja_options_editor_filmstrip_frame_count(inputs)
	if (locale === "hi") return hi_options_editor_filmstrip_frame_count(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_filmstrip_frame_count(inputs)
	return en_options_editor_filmstrip_frame_count(inputs)
});